import { Address, CustomerAddress } from 'src/interfaces/new-channel-partner/channelPartner';

export const resolve = (value: any) => (
  value ? `${value.trim()}, ` : ''
);

export const getAddressLine1 = (address: CustomerAddress) => {
  let nextWord = '';
  if (!address?.line2 && !address.landmark) {
    nextWord = address?.area;
  } else if ((address?.line2 && !address.landmark) || (address?.line2 && address.landmark)) {
    nextWord = `${address?.line2}`;
  } else if (!address?.line2 && address.landmark) {
    nextWord = address.landmark;
  }

  return address
    ? `${resolve(address?.line1)}${resolve(nextWord)}`
    : '--';
};

export const getAddressLine2 = (address: CustomerAddress) => {
  let nextWord: any = '';
  if (!address?.line2 && !address.landmark) {
    nextWord = address?.city;
  } else if ((address?.line2 && !address.landmark)) {
    nextWord = `${resolve(address?.area)}${address?.city}`;
  } else if (!address?.line2 && address.landmark) {
    nextWord = `${resolve(address?.area)}${address?.city}`;
  } else {
    nextWord = `${resolve(address?.landmark)}${resolve(address?.area)}${address?.city}`;
  }

  return address
    ? `${nextWord} - ${address.pincode}`
    : '--';
};

export const getFullAddress = (address: CustomerAddress) => {
  const line1 = getAddressLine1(address);
  const line2 = getAddressLine2(address);
  return `${line1}${line2}`;
};

export const getAddress = (address: Address) => {
  if (address?.pincode) {
    if (address?.landmark) {
      return `${address.addressLine1}, ${address?.addressLine2},
       ${address?.landmark}, ${address?.city},
       ${address?.area}-${address?.pincode}`;
    }
    return `${address.addressLine1}, ${address?.addressLine2}, ${address?.city},
     ${address?.area}-${address?.pincode}`;
  }
  return '--';
};
